import styled, { css } from 'styled-components'
import loading from '@shared/assets/loading.svg'

const InnerLoading = styled.div`
  position: relative;
  width: 100%;

  ${(props) => props.active && css`
      &::after {
        content: "";
        background-image: url(${loading});
        background-repeat: no-repeat;
        background-position: center;
        width: 2rem;
        height: 2rem;
        position: absolute;
        z-index: 4;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;

        animation: container-spin 0.5s infinite linear;

        @keyframes container-spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(359deg);
          }
        }
      }

      &::before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 4;
        top: 0;
        left: 0;
        background: rgba(255, 255, 255, 1);
      }
      `}
`

export { InnerLoading }
